import DoublePopoverConfirm from "@/components/DoublePopoverConfirm/DoublePopoverConfirm";
import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { useDeleteOutboundTransport } from "@/hooks/useTransport";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { message } from "antd";
import { ReactNode } from "react";

export default function DeleteOutboundTransportAction({
  children,
  route,
  year,
  onSuccess,
}: {
  children: ReactNode;
  route?: {
    departure_facility_id: number;
    arrival_facility_id?: number;
    arrival_name: string;
    by_transport_category: boolean;
  };
  year?: number;
  onSuccess?: () => void;
}) {
  const translation = useTranslation();
  const deleteOutbound = useDeleteOutboundTransport();
  const analytics = useAnalytics();

  const handleDelete = async (year?: number) => {
    return deleteOutbound
      .mutateAsync({ route, year })
      .then(() => {
        message.success(translation.transport.deleteSuccess);
        analytics.track("Outbound Transport Route Deleted");
        onSuccess?.();
      })
      .catch((error) => {
        message.error(translation.errors.general);
      });
  };

  return (
    <DoublePopoverConfirm
      trigger={["click"]}
      title={"Delete inbound transport data"}
      description={
        <>
          <p>
            This action will permanently delete outbound transport data{route && " for this route"}.
          </p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      onConfirm1={() => handleDelete()}
      button1Props={{ children: `Delete all`, danger: true }}
      onConfirm2={() => handleDelete(year)}
      button2Props={{ children: `Delete ${year}`, danger: true }}
      cancelButtonProps={{ children: translation.general.cancel }}
      placement="bottom"
    >
      <>{children}</>
    </DoublePopoverConfirm>
  );
}
